import React from 'react';
import vars from '@variables';
import {
  HighlightAtom,
  HighlightAuthorAtom,
} from '@atoms/text-atoms/text-atoms';
import { HighlightBlockProps } from './highlight-block.types';
import {
  HighlightBlockContainer,
  ContentContainer,
  DottedLine,
  AuthorImage,
  JobTitleOrganisation,
  AuthorContainer,
  HighlightFrame,
} from './highlight-block.styles';
import { getImage } from 'gatsby-plugin-image';

const HighlightBlock: React.FC<HighlightBlockProps> = ({
  anchorId,
  quote,
  author,
  maxHeight,
  className,
  authorImage,
  jobTitleOrganisation,
  quoteTextColor = vars.coreDarkGrey,
  hasDottedLines,
  narrowWidth = false,
}) => {
  const gatsbyImage = authorImage
    ? getImage(authorImage.gatsbyImageData)
    : null;

  if (quote) {
    return (
      <HighlightBlockContainer
        id={anchorId}
        className={className}
        data-testid="highlight-block"
        maxHeight={maxHeight}
        style={{ color: quoteTextColor }}
        narrow={narrowWidth}
      >
        <HighlightFrame useDottedLine={hasDottedLines} />
        {hasDottedLines && <DottedLine data-testid="dotted-line" />}
        <ContentContainer
          colour={quoteTextColor}
          data-testid="content-container"
        >
          {quote && <HighlightAtom data-testid="quote">{quote}</HighlightAtom>}
          <AuthorContainer data-testid="author-container">
            {authorImage && gatsbyImage && (
              <AuthorImage
                image={gatsbyImage}
                alt={author || ''}
                data-testid="author-image"
              />
            )}
            <div>
              {author && (
                <HighlightAuthorAtom data-testid="author">
                  {author}
                </HighlightAuthorAtom>
              )}
              {jobTitleOrganisation && (
                <JobTitleOrganisation data-testid="job-title-organisation">
                  {jobTitleOrganisation}
                </JobTitleOrganisation>
              )}
            </div>
          </AuthorContainer>
        </ContentContainer>
        {hasDottedLines && <DottedLine data-testid="dotted-line" />}
        <HighlightFrame useDottedLine={hasDottedLines} />
      </HighlightBlockContainer>
    );
  }
  console.warn(`Highlight Block Component called with null data`);
  return null;
};

export default HighlightBlock;
